import React, { FunctionComponent } from "react";
import Layout from "../../containers/layout";

const Stempeers2019: FunctionComponent = () => (
  <Layout showImageHeader imageHeaderPath="/images/pattern-nyc18-2.png">
    <div className="flex justify-center">
      <div className="lg:w-3/4 mt-8 pb-8">
        <img src="/images/download.jpeg" />
      </div>
    </div>
  </Layout>
);

export default Stempeers2019;
